import { Link } from "react-router-dom";
import { insights } from "../data/content";

export default function Insights() {
  return (
    <section
      id="insights"
      data-testid="insights-section"
      className="relative px-6 md:px-12 py-24 md:py-32 border-b border-rule bg-paper"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-3">
            <div className="overline text-slate reveal">Writing</div>
            <div className="mono text-xs text-slate mt-3 reveal">— 07</div>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2
              data-testid="insights-heading"
              className="serif text-3xl sm:text-4xl md:text-5xl font-light tracking-tight leading-[1.05] text-ink reveal"
            >
              Notes on operations, leverage, and AI
            </h2>
          </div>
        </div>

        <div className="border-t border-rule">
          {insights.map((post) => (
            <Link
              key={post.slug}
              to={`/insights/${post.slug}`}
              data-testid={`insight-card-${post.slug}`}
              className="group grid grid-cols-12 gap-6 md:gap-10 py-7 md:py-9 border-b border-rule hover:bg-sand/40 transition-colors duration-200 px-2 -mx-2"
            >
              <div className="col-span-12 md:col-span-2 flex items-baseline gap-3">
                <span className="overline text-slate">{post.date}</span>
              </div>
              <div className="col-span-12 md:col-span-7">
                <h3 className="serif text-xl md:text-2xl lg:text-[28px] font-light leading-tight text-ink group-hover:text-brass transition-colors">
                  {post.title}
                </h3>
                <p className="mt-2 text-sm md:text-base text-ink/70 leading-relaxed">
                  {post.dek}
                </p>
              </div>
              <div className="col-span-12 md:col-span-3 flex md:justify-end items-baseline gap-3">
                <span className="overline text-slate">{post.readTime}</span>
                <span className="text-ink group-hover:text-brass group-hover:translate-x-1 transition-all duration-200">→</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
